import React from 'react';
import { useSelector } from 'react-redux';
import { useQueryClient } from 'react-query';
import { Popconfirm, Button, Icon } from 'antd';
import useDeleteRoomImageMutation from '../../../../../mutations/useDeleteRoomImageMutation';
import { roomQueryKeys } from '../../../../../queries/queryKeys';
import styles from '../CommonInfoBlock.module.scss';
import { getEditingRoomData } from '../../../../../utils/getEditingRoomData';

const Photo = ({ photo, style, room, onPhotoClick }) => {
  const userCanDelete = useSelector(
    (store) => store.authentication.userInfo.CanDeleteOffice
  );

  const queryClient = useQueryClient();

  const { mutate: deleteImageMutate, isLoading: isDeleteImageLoading } =
    useDeleteRoomImageMutation({
      onSuccess: () => queryClient.invalidateQueries(roomQueryKeys(room?.id)),
    });

  const handleDeleteConfirm = () => {
    const data = getEditingRoomData(room);

    deleteImageMutate({ imageId: photo.id, room: data });
  };

  return (
    <li className={styles.galleryItem} style={style}>
      <img
        className={styles.galleryPhoto}
        src={photo.src}
        alt="изображение объекта"
        onClick={onPhotoClick}
      />
      {userCanDelete && (
        <Popconfirm
          placement="leftBottom"
          title="Удалить фото?"
          okText="Да"
          cancelText="Нет"
          onConfirm={handleDeleteConfirm}
          disabled={isDeleteImageLoading}
        >
          <Button
            className={styles.deleteImageBtn}
            type="danger"
            shape="circle"
            ghost
          >
            <Icon type="delete" theme="filled" />
          </Button>
        </Popconfirm>
      )}
    </li>
  );
};

export default Photo;
